if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        // Auf dem Handy: statt der umstaendlichen Slider-Modal eine schlichte Einzelbild-Vorschau
        // (nur DAS angetippte Bild, gross; Tippen irgendwo schliesst). Ab 750px die normale Zoom-Modal.
        if (window.matchMedia('(max-width: 749px)').matches) { this.showMobilePreview(opener); return; }
        super.show(opener);
        this.showActiveMedia();
      }

      showMobilePreview(opener) {
        const holder = opener && opener.closest ? (opener.closest('modal-opener, .product__modal-opener') || opener) : opener;
        const img = holder && holder.querySelector ? holder.querySelector('.product__media img, img') : null;
        if (!img) return;
        let src = img.currentSrc || img.src;
        if (img.srcset) {
          const best = img.srcset.split(',').map((s) => s.trim().split(/\s+/)).filter((p) => p[0]).sort((a, b) => (parseInt(b[1]) || 0) - (parseInt(a[1]) || 0))[0];
          if (best) src = best[0];
        }
        if (!src) return;
        let ov = document.getElementById('ti-image-preview');
        if (!ov) {
          const style = document.createElement('style');
          style.textContent = '#ti-image-preview{position:fixed;inset:0;z-index:1000;display:none;align-items:center;justify-content:center;background:rgba(0,0,0,.92);padding:14px;box-sizing:border-box}#ti-image-preview.open{display:flex}#ti-image-preview img{max-width:100%;max-height:100%;object-fit:contain;border-radius:6px;user-select:none}#ti-image-preview .ti-close{position:absolute;top:14px;right:14px;width:44px;height:44px;border:0;border-radius:50%;background:rgba(255,255,255,.16);color:#fff;font-size:26px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center}';
          document.head.appendChild(style);
          ov = document.createElement('div');
          ov.id = 'ti-image-preview';
          ov.innerHTML = '<img alt=""><button type="button" class="ti-close" aria-label="Schliessen">\u00d7</button>';
          document.body.appendChild(ov);
          const close = () => { ov.classList.remove('open'); document.body.classList.remove('overflow-hidden'); };
          ov.addEventListener('click', close);
        }
        ov.querySelector('img').src = src;
        ov.classList.add('open');
        document.body.classList.add('overflow-hidden');
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
